import { values } from './enums'

const _enum = {
  None: 0,
  IndividualPersonalIds: 1 << 0,
  IndividualAddresses: 1 << 1,
  IndividualContacts: 1 << 2,
  IndividualBans: 1 << 3,
  IndividualCbiEmployee: 1 << 4,
  IndividualCourses: 1 << 5,
  IndividualEducation: 1 << 6,
  IndividualExperience: 1 << 7,
  IndividualRelatedPersons: 1 << 8,
  IndividualGovernmentService: 1 << 9,
  IndividualCbsReport: 1 << 10,
  IndividualBlacklists: 1 << 11,
  IndividualCbiBlacklists: 1 << 12,
  IndividualChangeHistory: 1 << 13,
  IndividualUserAccounts: 1 << 14
}

export const individualPermissionTypes = {
  enumName: 'IndividualPermissionTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/individualPermissionTypes.js